import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeBuyPackageModal } from '../../../../slices';
import { paymentModalClose } from '../../../../services/event/paymentModalClose';
import { Package } from './components/Package';
import { PackageWithHold } from './components/PackageWithHold';
import { PackageWithRedirect } from './components/PackageWithRedirect';
import { SubscriptionWithHold } from './components/SubscriptionWithHold';
import { ESuccessModalType } from '../../../../types/successModalType';
import { Subscription } from './components/Subscription';
import { selectSuccessModalType } from '../../../../selectors/successScreens';
import { selectAnalyticsLabel } from '../../../../selectors/analytics';
import { trackSuccessPopupOpen } from './tracking';

export const SuccessScreensContainer = () => {
  const successModalType = useSelector(selectSuccessModalType);
  const analyticsLabel = useSelector(selectAnalyticsLabel);

  const dispatch = useDispatch();

  const handleClose = React.useCallback(() => {
    dispatch(closeBuyPackageModal());

    paymentModalClose();
  }, [dispatch]);

  React.useEffect(() => {
    trackSuccessPopupOpen(analyticsLabel);
  }, [analyticsLabel]);

  switch (successModalType) {
    case ESuccessModalType.PackageWithHold:
      return <PackageWithHold onClick={handleClose} />;

    case ESuccessModalType.Subscription:
      return <Subscription onClick={handleClose} />;

    case ESuccessModalType.SubscriptionWithHold:
      return <SubscriptionWithHold onClick={handleClose} />;

    case ESuccessModalType.PackageWithRedirect:
      return <PackageWithRedirect onClose={handleClose} />;

    default:
      // В случае типа Package и любой непонятной ситуации — показываем базовую модалку
      return <Package onClick={handleClose} />;
  }
};
